module.exports = __webpack_public_path__ + "img/chart-stack-bar-hori.0675c23e.svg";